"use strict";
$(document).ready(function () {
    // $(".shopify-section-group-footer-group").addClass("scroll-section");
    // $(".footer-block--newsletter").removeClass("animate--slide-in");
    // $(".footer__content-bottom").removeClass("animate--slide-in");
    let templateSuffix = $("body").attr("data-template-suffix");
    let templateName = $("body").attr("data-template");
    if(templateSuffix == 'brand'){
        $(".shopify-section-group-footer-group").addClass("scroll-section");
    }
    let navbar = document.querySelector(".custom-header__wrapper");


    function isTouchDevice() {
        return (('ontouchstart' in window) ||
           (navigator.maxTouchPoints > 0) ||
           (navigator.msMaxTouchPoints > 0));
    }

    $(".scroll-section:first-child").addClass("active");
    $(".scroll-section:first-child").addClass("view");

    let scrollSection = document.querySelectorAll(".scroll-section");
    scrollSection.forEach((item, index) => {

        if (!isTouchDevice()) {
            item.addEventListener('wheel', function(e) {
                if (e.deltaY > 0) {
                    if (index+1 !== scrollSection.length) {
                        item.classList.remove('view');
                        $(this).next().addClass('active');
                        $(this).next().addClass('view');
                    }
                    if(templateSuffix == 'brand'){
                        navbar.classList.add("scroll-header");
                    }
                } else {
                    let parentClass = $(this).closest(".scroll-section");
                    if (index === 1) {
                        navbar.classList.remove("scroll-header");
                    }
                    if(templateSuffix != "brand"){
                        if (index !== 0) {
                            parentClass.removeClass('active');
                            parentClass.removeClass('view');
                            parentClass.prev().addClass('view');
                        }
                    }
                    else{
                        if (!e.target.closest('.iti__country-list')) {
                            if (index !== 0) {
                                parentClass.removeClass('active');
                                parentClass.removeClass('view');
                                parentClass.prev().addClass('view');
                            }
                        }
                    }
                }
            })
        }

    })

    $(document).keydown(function(e) {
        scrollSection.forEach((item, index) => {
            let viewport = item.getBoundingClientRect();
            if (viewport.top === 0) {
                if(e.which === 39){
                    let hasSwiper = item.querySelector(".swiper");
                    if(hasSwiper){
                        hasSwiper.swiper.slideNext();
                    }
                }
                if(e.which === 37){
                    let hasSwiper = item.querySelector(".swiper");
                    if(hasSwiper){
                        hasSwiper.swiper.slidePrev();
                    }
                }
                if (e.which === 40) {
                    if (index+1 !== scrollSection.length) {
                        item.classList.remove('view');
                        scrollSection[index+1].classList.add('active');
                        scrollSection[index+1].classList.add('view');
                        if(templateSuffix == 'brand'){
                            navbar.classList.add("scroll-header");
                        }
                    }
                } else if (e.which === 38) {
                    if (index !== 0) {
                        if (scrollSection[index].classList.contains('view')) {
                            scrollSection[index].classList.remove('active');
                            scrollSection[index].classList.remove('view');
                            scrollSection[index-1].classList.add('view');
                        }
                    }
                    if (index === 1) {
                        if(templateSuffix == 'brand'){
                            navbar.classList.remove("scroll-header");
                        }
                    }
                }
            }
        })
    });

    // Initialize swiper in landing page
    let landingSwipers = document.querySelectorAll(".landing-swiper");
    landingSwipers.forEach(item => {
        let swiperID = item.getAttribute('id');
        let templateID = swiperID.substring(swiperID.indexOf('template'), swiperID.length);
        var swiper = new Swiper('#'+swiperID, {
            navigation: {
                nextEl: ".swiper-button-next_"+templateID,
                prevEl: ".swiper-button-prev_"+templateID,
            },
        });
    })

    // Landing footer
    if(templateSuffix != "brand"){
        let footer = document.querySelector(".landing-main-content footer");
        let lastScrollSection = $( ".scroll-section" ).last().find(".scrolling-area");
        lastScrollSection.append(footer);
    }
    // else{
    //     setTimeout(function(){
    //         let footerContentHeight = 0;
    //         $(".shopify-section-group-footer-group > *").each(function(){
    //             footerContentHeight += $(this).outerHeight();
    //         });
    //         $(".shopify-section-group-footer-group").attr("style", `height: ${footerContentHeight}px;`);
    //     }, 2000);
    // }

    if (isTouchDevice()) {
        $(".landing-main-content").addClass("custom-scroll-container");
        $(".scroll-section").addClass("custom-scroll-section");
        if(templateSuffix == "brand"){
            $(".shopify-section-group-footer-group").attr("style", "height: auto !important; position: static;");
            // $(".section--scroll-element").last().find(".landing-page__title").css({"padding": "40px 0"});
        }
    }
    else{
        $(".landing-main-content").removeClass("custom-scroll-container");
        $(".scroll-section").removeClass("custom-scroll-section");
    }

    if(templateSuffix == 'brand'){
        let startClientY, endClientY;
        window.addEventListener("touchstart", (event) => {
            startClientY = event.touches[0].pageY;
        }, true);

        window.addEventListener.bind("touchmove", (event) => {
            endClientY = event.touches[0].pageY;
        }, true);

        let slideHeight = window.offsetHeight;
        window.addEventListener("touchstart", function (event) {
        startClientY = event.touches[0].pageY;
        }, {
            capture: true,
            passive: true
        });

        window.addEventListener("touchmove", function (event) {
            endClientY = event.touches[0].pageY;
        }, {
            capture: true,
            passive: true
        });

        window.addEventListener("touchend", (event) => {
            event.preventDefault();
            let diff = startClientY - endClientY;
            if (diff < -35) {
                if (i !== 0) {
                    window.scrollBy(0, -slideHeight);
                    i--;
                    if (scrollSection[i] === scrollSection[0]) {
                        navbar.classList.remove("scroll-header");
                    }
                }
            } else if (diff > 35) {
                if (i < scrollSection.length - 1) {
                    window.scrollBy(0, slideHeight);
                    i++;
                    navbar.classList.add("scroll-header");
                }
            }
            startClientY = undefined;
            endClientY = undefined;
        }, {
            capture: true,
            passive: true
        });
    }
})